import { Component, OnInit, ChangeDetectionStrategy, ContentChildren, QueryList, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ViewTourPageComponent } from '../view-tour-page/view-tour-page.component';
import { Select, Store } from '@ngxs/store';
import { ViewState } from 'src/app/view/state/view.state';
import { Observable, Subject } from 'rxjs';
import { TutorialStateModel } from 'src/app/view/models/tutorial-state.model';
import { ViewActions } from 'src/app/view/state/view.actions';
import { filter, takeUntil } from 'rxjs/operators';
import { ViewWindow } from 'src/app/view/models/view-window.enum';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-view-tour-pages',
  templateUrl: './view-tour-pages.component.html',
  styleUrls: ['./view-tour-pages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewTourPagesComponent implements OnInit, AfterViewInit, OnDestroy {

  @ContentChildren(ViewTourPageComponent) pages: QueryList<ViewTourPageComponent>;

  @Select(ViewState.getTutorial)
  tutorial$: Observable<TutorialStateModel>;

  private ngUnsubscribe = new Subject();
  private index: number = null;

  constructor(
    private store: Store,
    private changeRef: ChangeDetectorRef,
    private ga: GoogleAnalyticsService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // handle page navigation
    this.tutorial$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter(tutorial => tutorial != null && tutorial.pageSize > 0)
      )
      .subscribe((tutorial) => {
        this.handleTutorialPages(tutorial);
      });
      
    // init tour
    this.store.dispatch(new ViewActions.SetTutorial({
      pageSize: this.pages.length,
      pageIndex: 0
    }));
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handlePrevClick() {
    this.store.dispatch(new ViewActions.TutorialPrevious());
  }

  handleNextClick() {
    this.store.dispatch(new ViewActions.TutorialNext());
  }

  handleExitClick() {
    this.store.dispatch(new ViewActions.ToggleWindow(ViewWindow.Tutorial, false));
  }

  private handleTutorialPages(tutorial: TutorialStateModel) {
    this.pages.forEach((group, groupIndex) => {
      group.shown = groupIndex === tutorial.pageIndex;
    });

    this.ga.event('Viewed Tutorial Step', 'View Tutorial', `Step ${tutorial.pageIndex + 1} of ${tutorial.pageSize}`);

    this.changeRef.markForCheck();
  }

}
